import enviro from 'enviro';
export function getSourceId(productType, productId) {
  return [`${String(productType)}__${productId}`];
}
var MARKETPLACE_CTA_ACTION;
(function (MARKETPLACE_CTA_ACTION) {
  MARKETPLACE_CTA_ACTION["HEADER_CONNECT"] = "header_connect";
  MARKETPLACE_CTA_ACTION["HEADER_RECONNECT"] = "header_reconnect";
  MARKETPLACE_CTA_ACTION["SIDEBAR_SUPPORT"] = "sidebar_support";
  MARKETPLACE_CTA_ACTION["SIDEBAR_SETUP_GUIDE"] = "sidebar_setup_guide";
  MARKETPLACE_CTA_ACTION["SIDEBAR_FACEBOOK"] = "sidebar_facebook";
  MARKETPLACE_CTA_ACTION["SIDEBAR_COMPANY"] = "sidebar_company";
  MARKETPLACE_CTA_ACTION["SIDEBAR_LIVE_CHAT"] = "sidebar_live_chat";
  MARKETPLACE_CTA_ACTION["SIDEBAR_EMAIL_SUPPORT"] = "sidebar_email_support";
  MARKETPLACE_CTA_ACTION["MANAGE_APP_CLICK"] = "manage_app";
})(MARKETPLACE_CTA_ACTION || (MARKETPLACE_CTA_ACTION = {}));
const isQa = () => enviro.isQa();
export const trackCustomMarketplaceOfferingBehavioralEvent = action => {
  const _hsq = window._hsq || [];
  _hsq.push(['trackCustomBehavioralEvent', {
    name: isQa() ? 'pe53_marketplace_offerings_cta_clicks_qa' : 'pe53_marketplace_offerings_cta_clicks',
    properties: {
      marketplace_cta_action: MARKETPLACE_CTA_ACTION[action]
    }
  }]);
};